import React, { Component } from 'react';
import moement from 'moment-timezone';
import Loading from '../components/loading';
import fetcher from '../API';

const DEFAULT_AVATAR = 'http://via.placeholder.com/40x40';

class ProductCommentRow extends Component {
    render() {
        const { comment } = this.props || {};
        const {
            content,
            userAvatar,
            userLabel,
            pictures,
            postedAt,
        } = comment || {}

        let postedAtDateStr = '';
        if (postedAt) {
            postedAtDateStr = moement(postedAt).format('YYYY/MM/DD HH:mm');
        }

        let picturesRow;
        if (pictures) {
            picturesRow = pictures.map(p => {
                return (
                    <div className='col-xs-6 col-md-4'
                        key={ p.id }>
                        <a href={ `${p.full.url}` } target='_blank'>
                            <img src={ p.thumbnail.url } className='img-thumbnail' />
                        </a>
                    </div >
                )
            })
        };

        return (
            <li className="list-group-item" >
                <div className='row mt-3 ml-1'>
                    <div className='media'>
                        <img width='50px'
                            className='rounded-circle mr-3'
                            src={ userAvatar || DEFAULT_AVATAR }
                        />
                        <div className='media-body'>
                            <h5 className='mt-0'>{ userLabel || "" }</h5>
                            { postedAtDateStr }
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <span className='col-xs-12 col-md-12'>{ content }</span>
                </div>
                <div className="row mt-3 mb-3">
                    { picturesRow }
                </div>
            </li>
        )
    }
}

class ProductComments extends Component {
    state = {
        comments: [],
        isLoading: false,
        isAllLoaded: false,
        isEmpty: false,
    }

    componentDidMount() {
        this.fetchProductComments(0);
    }

    handleLoadMore = () => {
        this.fetchProductComments(this.state.comments.length);
    }

    fetchProductComments = (from) => {
        const productId = this.props.productId;
        const pageSize = 20;
        const to = from + pageSize;
        const url = `api/v1/product-comment/products/${productId}/comments?&f=${from}&t=${to}`
        this.setState({ isLoading: true });
        fetcher.get(url).then((response) => {
            if (!response.data) {
                return;
            }
            let comments = this.state.comments;
            if (response.data.from === 0) {
                comments = response.data.comments;
            } else {
                comments = [...comments, ...response.data.comments];
            }
            const isEmpty = response.data.total === 0;
            const isAllLoaded = comments.length === response.data.total;
            this.setState({
                isLoading: false,
                comments: comments,
                isAllLoaded: isAllLoaded,
                isEmpty: isEmpty,
            });
        });
    }

    render() {
        const {
            comments,
            isLoading,
            isAllLoaded,
            isEmpty,
        } = this.state || {};
        let loadMoreButton = (
            <button type="button" className="btn btn-info" onClick={ this.handleLoadMore }>Load More</button>
        )
        if (isAllLoaded) {
            loadMoreButton = (
                <button type="button" className="btn btn-secondary disabled"> All comment loaded</button>
            )
        }
        let content;
        if (isLoading) {
            // if comments is null, then show loading
            content = <Loading spinning />;
        } else if (isEmpty) {
            content = (
                <div className="alert alert-warning" role="alert">
                    no comments for this product.<br />
                    这个产品没有相关评论
                </div>
            )
        } else {
            content = (
                <React.Fragment>
                    <ul className="list-group">
                        {
                            comments.map(c => {
                                return (
                                    <ProductCommentRow key={ c.id } comment={ c } />
                                )
                            })
                        }
                    </ul>
                    <div className="mt-3">{ loadMoreButton }</div>
                </React.Fragment>
            )
        }
        return (
            <div className='bg-light pt-3' style={{position: 'relative', minHeight: '200px'}}>
                <h4 className="mb-3">产品评论</h4>
                { content }
            </div>
        );
    }
}

export default ProductComments;
